import React from 'react'
import { Chip } from '@mui/material'

import { dsColorNew } from '@palette'


// How many office chips the field shows before "+N" (CU-869fmk5ge: goal 4 fills every BI office, ~320 for a group)
export const OFFICE_TAGS = 1

const CHIP_SX = {
	maxWidth: 150, minWidth: 56, flexShrink: 1,
	'& .MuiChip-label': { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' },
}

/**
 * The Pick up Office field of Advanced (BI) on one line whatever it holds (same rule as KindPillsField, 5f6c05f2):
 * - the first office as a chip with its name, shrinking with an ellipsis, the full name on hover (one chip: two would
 *   leave a few letters each in a 3-column field; the flag and type icons of the options would leave none);
 * - then a "+N" that never shrinks;
 * - while the field is focused every chip is there, still on one line, so the band never grows.
 * Props of BI's config only: the shared filter is untouched.
 */
export const oneLineOfficeTagsProps = {
	limitTags: OFFICE_TAGS,
	getLimitTagsText: more => `+${more}`,
	renderTags: (values, getTagProps) => values.map((op, index) => <Chip
		color="primary"
		size="small"
		title={op.label}
		label={op.label}
		{...getTagProps({ index })}
		key={op.value}
		sx={CHIP_SX}
	/>),
	sx: {
		'& .MuiAutocomplete-inputRoot': { flexWrap: 'nowrap', overflow: 'hidden' },
		// the empty text input takes no room until the field is focused, so the chip keeps its name
		'& .MuiAutocomplete-inputRoot:not(.Mui-focused) input': { minWidth: 0, width: 0, px: 0 },
		'& span.MuiAutocomplete-tag': { flexShrink: 0, color: dsColorNew.appBlue, fontWeight: 600, fontSize: 12, backgroundColor: 'transparent' },
	},
}
